import { render, staticRenderFns } from "./DataDownload.vue?vue&type=template&id=56dea9b3&scoped=true"
import script from "./DataDownload.vue?vue&type=script&lang=js"
export * from "./DataDownload.vue?vue&type=script&lang=js"
import style0 from "./DataDownload.vue?vue&type=style&index=0&id=56dea9b3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dea9b3",
  null
  
)

export default component.exports